var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2833 18.2919C13.7496 17.0836 16.666 15.0002 16.666 10.8334V4.99983C16.666 4.77881 16.5782 4.56684 16.4219 4.41056C16.2657 4.25427 16.0537 4.16647 15.8327 4.16647C14.1662 4.16647 12.0914 3.17477 10.6333 1.89973C10.4567 1.74889 10.2322 1.66602 9.99998 1.66602C9.7678 1.66602 9.54324 1.74889 9.36671 1.89973C7.91686 3.16644 5.83373 4.16647 4.16723 4.16647C3.94624 4.16647 3.7343 4.25427 3.57804 4.41056C3.42177 4.56684 3.33398 4.77881 3.33398 4.99983V10.8334C3.33398 15.0002 6.25036 17.0836 9.72501 18.2836C9.90461 18.3505 10.1018 18.3534 10.2833 18.2919Z",
    stroke: "#555555",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.fe1e56f6c3ac0af464e1aec24f7d1f84.svg";
export { ForwardRef as ReactComponent };